import styled from "styled-components";
import { styled as muiStyled } from '@mui/material/styles';
import { Box } from "@mui/material";

export const AvatarCellStyles = muiStyled(Box)(({ }) => ({
    '.avatar-img': {
        width: 35,
        height: 35
    }
}));


export const WrapWarningCell = styled.div`

`

export const TestTakerDetails = styled.div`
font-size:16px;
`